/* eslint-disable import/no-internal-modules */
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { getAnalytics } from 'firebase/analytics';
import { RouterProvider } from 'react-router-dom';
import { Slide, ToastContainer } from 'react-toastify';
import { ThemeProvider } from 'styled-components';
import { initializeApp } from 'firebase/app';

import 'react-toastify/dist/ReactToastify.css';

import { COLORS } from '@_shared/styles';

import router from './router';
import { DefaultStyle, DefaultFont } from './styles/defaultStyle';
import './styles/toast.css';

const firebaseConfig = {
	apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
	authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
	projectId: import.meta.env.VITE_FIREBASE_Project_ID,
	storageBucket: import.meta.env.VITE_FIREBASE_Storage_Bucket,
	messagingSenderId: import.meta.env.VITE_FIREBASE_Messaging_Seder_ID,
	appId: import.meta.env.VITE_FIREBASE_APP_ID,
	measurementId: import.meta.env.VITE_FIREBASE_Measurement_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
getAnalytics(app);

const queryClient = new QueryClient();

function App() {
	return (
		<ThemeProvider theme={COLORS}>
			<QueryClientProvider client={queryClient}>
				<DefaultFont />
				<DefaultStyle />
				<ToastContainer
					position="bottom-center"
					autoClose={3000}
					limit={3}
					hideProgressBar
					newestOnTop
					closeOnClick={false}
					rtl={false}
					pauseOnFocusLoss={false}
					draggable
					pauseOnHover={false}
					theme="light"
					transition={Slide}
				/>
				<RouterProvider router={router} />
				<ReactQueryDevtools initialIsOpen={false} />
			</QueryClientProvider>
		</ThemeProvider>
	);
}

export default App;
